import { setSnackbarMessage } from "store/ui/uiSlice";

const errorHandlerMiddleware = ({ dispatch, getState }:any) => (next:any) => (action:any) => {
  const { type, payload } = action;

  if ( type.includes('/rejected') ){
    if (payload?.status === 409) {
      const { quiz } = getState().quiz;
      if (quiz.registrationPage && !quiz.registrationPage.anonymous) {
        return next(action);
      }
    }

    if (payload?.status === 502) {
      dispatch(setSnackbarMessage('Sorry, our service is currently experiencing high demand. Please try again.'));
      return next(action);
    }

    if ( typeof payload !== 'undefined' ){
      if ( payload?.message ){
        dispatch(setSnackbarMessage(payload.message));
      }
    } else {
      dispatch(setSnackbarMessage('Something wen`t wrong'));
    }
  }
  return next(action);
}

export default errorHandlerMiddleware;
